export interface AxleReadingValue {
  position: number;
  loadTn: string; // decimal string, accepts '.' or ','
}

export interface OperatorFormValues {
  vehiclePlate: string;
  ownerName: string;
  fromCityId: number | "";
  toCityId: number | "";
  // Weighing (decimal strings — operator types whatever, normalized on submit)
  totalMassTn: string;
  frontAxleTn: string;
  totalAxles: string;
  perAxleEnabled: boolean;
  axleReadings: AxleReadingValue[];
  // Permit is not an operator choice — the engine derives it from the
  // weights/oversize; the UI shows it read-only.
  isOversized: boolean;
}

export const emptyForm: OperatorFormValues = {
  vehiclePlate: "",
  ownerName: "",
  fromCityId: "",
  toCityId: "",
  totalMassTn: "",
  // Front axle is ~6 t on virtually every truck — default it so the operator
  // rarely has to touch it.
  frontAxleTn: "6",
  totalAxles: "",
  perAxleEnabled: false,
  axleReadings: [],
  isOversized: false,
};
